var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeams2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920.01,
    height: 874.025,
    viewBox: "0 0 1920.01 874.025",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.012,
    cy: 1,
    r: 1.478,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#49ad3b",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.987,
    stopColor: "#f18219",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2db9ca",
    stopOpacity: 0.169
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_39326",
    "data-name": "Path 39326",
    d: "M-.071-26.939l261.837,15.46,728.274-73.7L1917.627-24.61c2.6,0,0,757.111,0,757.111,0,2.577-111.438,11.292-114.039,11.292,0,0-825.724,47.136-838.453,44.986l-696.6-73.605c-2.6,0-268.61,26.53-268.61,23.953V-1.011C-.071-3.589-2.672-26.939-.071-26.939Z",
    transform: "translate(1.227 85.176)",
    opacity: 0.59,
    fill: "url(#radial-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams2);
export default __webpack_public_path__ + "static/media/teams2.841b93981373672336b126235a863cc2.svg";
export { ForwardRef as ReactComponent };